import { render, staticRenderFns } from "./contacts-profile.vue?vue&type=template&id=e2975ed0&"
import script from "./contacts-profile.vue?vue&type=script&lang=js&"
export * from "./contacts-profile.vue?vue&type=script&lang=js&"
import style0 from "./contacts-profile.vue?vue&type=style&index=0&id=e2975ed0&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports